export enum Authority {
  ROLE_PRESENTER_USER,
  ROLE_PRESENTER_ADMIN,
}
